 import find from 'lodash/find';

 export class SocialShareService {
     constructor($resource, ApiService) {
         'ngInject';

        this.$resource = $resource;
		this.apiService = ApiService;

        this.socialShareResourceUrl = this.apiService.getResourceUrl('cms/menus/SocialShare');
        this.editSocialShareResourceUrl = this.apiService.getResourceUrl('cms/social-share');

        this.socialShareResource = this.$resource(this.socialShareResourceUrl);
        this.editSocialShareResource = this.$resource(this.editSocialShareResourceUrl,null,{
            update: {
                method: 'PUT'
            }
        });
     }

     _getSubContentDetails({social_share_app_ids:socialShareAppIds}) {
        return socialShareAppIds.map(({name,app_id:appId}) => ({name, appId, isCorrect: appId ? true : false}));
    }

    _setSubContentDetails(value) {
		return {
			social_share_app_ids: this._setSocialShareAppIds(value)
		}
	}

    _setSocialShareAppIds(values) {
        return values.map(({name,appId}) => ({name, app_id:appId.trim()}));
    }

     /************
      * To get SocialShare App Ids
      ***************/
      getSocialShareAppIds({data}) {
          return this._getSubContentDetails(find(data.content, ['name', 'SocialShare']).values[0])
      }

      /*************
       * To Update SocialShare App Ids
       *****************/
      editSocialShareAppIds(details) {
        const promise = this.editSocialShareResource.update(this._setSubContentDetails(details)).$promise;

        return promise
            .then(details => details)
            .catch(err => {
                throw this.apiService.getErrorMessage(err);
            })
      }

      validateFacebookAppId(appId) {
        const facebookAppIdValidationResourceUrl = `https://graph.facebook.com/${appId}`;
        const facebookAppIdValidationResource = this.$resource(facebookAppIdValidationResourceUrl);

        const promise = facebookAppIdValidationResource.get().$promise;

        return promise
            .then(details => details);
      }
 }


// WEBPACK FOOTER //
// ./src/app/components/social-share/social-share.service.js